(() => {
  class FilterJourney extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.steps = [...this.querySelectorAll('[data-filter-step]')];
      this.stage = this.querySelector('.hd-filter__stage');
      this.model = this.querySelector('[data-filter-model]');
      this.phase = this.querySelector('[data-filter-phase]');
      this.index = this.querySelector('[data-filter-index]');
      this.progressBar = this.querySelector('[data-filter-progress]');
      this.schedule = () => {
        if (!this.near || this.frame || document.hidden) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      };
      addEventListener('scroll', this.schedule, { passive: true, signal: this.abort.signal });
      addEventListener('resize', this.schedule, { passive: true, signal: this.abort.signal });
      document.addEventListener('visibilitychange', this.schedule, { signal: this.abort.signal });
      this.motion.addEventListener('change', () => {
        this.classList.toggle('is-reduced', this.motion.matches);
        if (this.motion.matches) { this.scene?.dispose(); this.scene = null; this.classList.remove('is-3d'); }
        else if (this.near) this.loadScene();
        this.schedule();
      }, { signal: this.abort.signal });
      this.resize = new ResizeObserver(() => { this.scene?.resize(); this.schedule(); });
      this.resize.observe(this.stage);
      this.observer = new IntersectionObserver(entries => {
        this.near = entries[0].isIntersecting;
        if (this.near && !this.motion.matches) this.loadScene();
        this.schedule();
      }, { rootMargin: '400px' });
      this.observer.observe(this);
      this.classList.toggle('is-reduced', this.motion.matches);
    }
    async loadScene() {
      if (this.scene || this.loading || this.failed) return;
      this.loading = true;
      try {
        const { createFilterScene } = await import(this.dataset.sceneUrl);
        if (!this.isConnected || this.motion.matches) return;
        const scene = await createFilterScene(this.model, this.dataset.engineUrl);
        if (!this.isConnected || this.motion.matches) { scene.dispose(); return; }
        this.scene = scene;
        this.scene.resize();
        this.classList.add('is-3d');
        this.schedule();
      } catch { this.failed = true; this.classList.add('is-fallback'); }
      finally { this.loading = false; }
    }
    update() {
      const rects = this.steps.map(el => el.getBoundingClientRect());
      if (rects.length < 3) return;
      const clamp = n => Math.max(0, Math.min(1, n));
      const readingLine = innerWidth < 750 ? Math.min(innerHeight * .8, this.stage.getBoundingClientRect().bottom + 160) : innerHeight * .55;
      const start = rects[0].top + rects[0].height * .5;
      const end = rects[2].top + rects[2].height * .5;
      const progress = clamp((readingLine - start) / Math.max(1, end - start));
      const active = progress < .25 ? 0 : progress < .75 ? 1 : 2;
      this.steps.forEach((el, i) => {
        el.classList.toggle('is-active', i === active);
        if (i === active) el.setAttribute('aria-current', 'step'); else el.removeAttribute('aria-current');
      });
      this.phase.textContent = this.steps[active].dataset.filterLabel;
      this.index.textContent = `0${active + 1} / 03`;
      this.progressBar.style.transform = `scaleX(${progress})`;
      this.dataset.filterProgress = progress.toFixed(3);
      this.scene?.render(progress);
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect(); this.resize?.disconnect();
      cancelAnimationFrame(this.frame); this.frame = 0;
      this.scene?.dispose(); this.scene = null;
    }
  }
  if (!customElements.get('hydros-filter-journey')) customElements.define('hydros-filter-journey', FilterJourney);
})();
